import React from "react";
import {HashRouter} from "react-router-dom";
import {Bonuswelten} from "./Bonuswelten";

export function BonusweltenContainer(props) {
    return (
        <HashRouter>
            <Bonuswelten></Bonuswelten>
        </HashRouter>
    )
}
